import * as React from 'react';
import { IAppConfig, ICanary } from '../../types';
import { getUserInfoRequest } from '../../clients/userInfo';
import {
  ADMIN,
  FULLADMIN,
  LISTADMIN,
  READONLYUSER,
} from '../../constants/roles';

interface IAppGlobalContext {
  userdata: { username: string; roles: string[] };
  appConfig: IAppConfig;
  canary?: ICanary;
  refreshCanary: (canary: ICanary) => void;
}

const AppGlobalContext = React.createContext<IAppGlobalContext>({
  // eslint-disable-next-line
  appConfig: null as any,
  // eslint-disable-next-line
  canary: null as any,
  refreshCanary: () => null,
  userdata: { username: '', roles: [] },
});

interface AppGlobalContextProviderProps {
  children: React.ReactNode;
  appConfig: IAppConfig;
}

export const AppGlobalContextProvider = ({
  children,
  appConfig,
}: AppGlobalContextProviderProps) => {
  const [canary, setCanary] = React.useState<ICanary>();
  const [userdata, setUserData] = React.useState<{
    username: string;
    roles: string[];
  }>({
    username: '',
    roles: [],
  });

  const refreshCanary = (canary: ICanary) => {
    setCanary(canary);
  };

  React.useEffect(() => {
    getUserInfoRequest(appConfig.treatCanaryApiUrl)
      .then(userdata => {
        const filteredRoles = userdata.roles.includes(FULLADMIN)
          ? [FULLADMIN]
          : userdata.roles.includes(ADMIN)
          ? [ADMIN]
          : userdata.roles.includes(LISTADMIN)
          ? [LISTADMIN]
          : userdata.roles.includes(READONLYUSER)
          ? [READONLYUSER]
          : [];

        setUserData({
          username: userdata.userName.split('@')[0],
          roles: filteredRoles,
        });
      })
      .catch(reason => {
        console.error(reason);
      });
  }, [appConfig.treatCanaryApiUrl]);

  return (
    <AppGlobalContext.Provider
      value={{
        userdata,
        appConfig,
        canary,
        refreshCanary: refreshCanary,
      }}
    >
      {children}
    </AppGlobalContext.Provider>
  );
};

export const useGlobalContext = () => React.useContext(AppGlobalContext);
